import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const APPS_SETTINGS_ROUTE_NAMES = new Set<string>([
	ROUTE_NAMES.MARKETPLACE_INDEX,
	ROUTE_NAMES.MARKETPLACE_ADDONS_EMCEE,
	ROUTE_NAMES.MARKETPLACE_ADDONS_EMCEE_PUBLIC,
	ROUTE_NAMES.MARKETPLACE_MANAGE_APPS,
	ROUTE_NAMES.SETTINGS_OAUTH_CREDENTIALS,
]);
